import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridOptions } from "ag-grid/main";
import { ServerConstantsService, DataService, DateUtility, CommonUtility} from '../shared';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { saveAs } from 'file-saver';
import * as jsPDF from 'jspdf';
import { utils, write, WorkBook } from 'xlsx';

@Component({
    selector: 'app-monthly-snapshot-details',
    templateUrl: './monthly-snapshot-details.component.html',
    styleUrls: ['./monthly-snapshot-details.component.scss']
  })
  export class MonthlySnapshotDetailsComponent implements OnInit {

    private gridOptions: GridOptions;
    private gridCountOptions: GridOptions;
    ServerConstants: any;

    reportNames: any[];
    reportMonths: any[];
    reportAreas: any[];
    reportCounties: any[];
    reportProviders: any[];
    userActionNotificationsMap: any;
    report: any;
    reportMonth: any;
    reportAreaCode: any;
    reportCounty: any;
    reportProvider: any;

    searchSnapshotDetailsRequest: SearchSnapshotDetailsVO;

    areaDisabled: boolean = false;
    countyDisabled: boolean = false;
    providerDisabled: boolean = false;

    dataFound: boolean = false;
    errorMandatoryFields: string;
    errorMandatoryMonthField: string;
    sharedData: any;

    renderedTableContent: CitizenMonthlySnapshotDetailsVO[] = [];
    renderedCountTableContent: any[] = [];
    pdfDocument: boolean = false;
    excelDocument: boolean = false;
    ws: any;

    reportSelectedMonthName : string;
    reportSelectedCountyName : string;
    reportSelectedAreaName : string;
    reportSelectedProviderName : string;

    //Table variables
    monthlySnapshotDetailsRowData:any = [];
    monthlySnapshotDetailsCountRowData:any = [];
    
    monthlySnapshotDetailsColumnDefs:any = [];
    monthlySnapshotDetailsCountColumnDefs:any = [];
    gridMonthlySnapshotDetailsApi: any;
    gridMonthlySnapshotDetailsCountApi: any;
    gridApi: any;
    gridCountApi: any;
    context: any;
    contextCount: any;
    firstTime: Boolean = true;
    selectedValue: any;
    

    constructor(private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private dateUtil: DateUtility,
        private data: ReferenceTableService,
        private commonUtil: CommonUtility,
        private refTableService: ReferenceTableService,
        private notificationService: NotificationsService,
        public dataService: DataService,
        private serverConstantsService: ServerConstantsService
) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
    this.gridCountOptions = <GridOptions>{};
}
    ngOnInit() {

        this.sharedData = this.dataService.getSharedDataObject();
        this.getReportNames();
        this.getReportMonths();
        this.loadUserInformation();
        this.getUserActionNotifications();
              
        //Sets current report by default on dropdown.
        this.report = 'SD';
    }

    getReportNames() {
        let reports = this.refTableService.getValueFromSharedDataMap("REPORT_NAME");
        this.reportNames = [];
        for (let entry of reports) {
            this.reportNames.push(entry);
        }
    }

    loadUserInformation() {
      
      //  this.getReportProviders();
      
      this.http.post<any>(this.ServerConstants.REPORT_SERVER_API_URL+'/reportTaskSummary/loaduserdata', null).subscribe(
        data => {
            var role = '';
            if(data.hasOwnProperty('role')) {
                role = data['role'];
            }

            if (data.hasOwnProperty('areas')) {
                let userAreas = data['areas'];
                var keys = Object.keys(userAreas);
                this.reportAreas = [];
                if(role == 'System Coordinator' || role == 'Area Supervisor') {
                    var pickup = new DropdownValues();
                    pickup.value = undefined;
                    pickup.name = "Pick an option";
                    this.reportAreas.push(pickup);
                    var pickupAll = new DropdownValues();
                    pickupAll.value = "All"
                    pickupAll.name = "All";
                    this.reportAreas.push(pickupAll);
                    
                    for (let k of keys) {
                        var dv = new DropdownValues();
                        dv.value = userAreas[k];
                        dv.name = userAreas[k];
                        this.reportAreas.push(dv);
                    }
                } else {
                    this.areaDisabled = true;
                }
            }

            if (data.hasOwnProperty('counties')) {    
                let userCounties = data['counties'];
                var keys = Object.keys(userCounties);
  
                if((role !== 'County Supervisor') && (role !== 'County Worker')) {
                  let userCounties = data['counties'];
                  var keys = Object.keys(userCounties);
                  this.reportCounties = [];
                  var pickup = new DropdownValues();
                  pickup.value = undefined;
                  pickup.name = "Pick an option";
                  this.reportCounties.push(pickup);                
                  var pickup = new DropdownValues();
                  pickup.value = "All"
                  pickup.name = "All";
                  this.reportCounties.push(pickup);
                  for (let k of keys) {
                      var dv = new DropdownValues();
                      dv.value = k;
                      dv.name = userCounties[k];
                      this.reportCounties.push(dv);
                  }           
                 } else {
          
                    this.reportCounties = [];
                    for (let k of keys) {
                          var dv = new DropdownValues();
                          dv.value = k;
                          dv.name = userCounties[k];
                          this.reportCounties.push(dv);
                    }     
                    this.reportCounty  = this.reportCounties[0].value;            
                  }
                }
  
                if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
                {  
                    if (data.hasOwnProperty('providers')) {
                        let userProviders = data['providers'];
                        var keys = Object.keys(userProviders);
                        this.reportProviders = [];
                        
                        var pickup = new DropdownValues();
                        pickup.value = undefined;
                        pickup.name = "Pick an option";
                        this.reportProviders.push(pickup);                     
                        
                       /* var pickupAll = new DropdownValues();
                        pickupAll.value = "All"
                        pickupAll.name = "All";
                        this.reportProviders.push(pickupAll);*/
                        for (let k of keys) {
                            var dv = new DropdownValues();
                            dv.value = k;
                            dv.name = userProviders[k];
                            this.reportProviders.push(dv);
                        }    
                    }
                } else if(this.sharedData.get("roles")[0].id == 5) {
                  if (data.hasOwnProperty('providers')) {
                      let userProviders = data['providers'];
                      var keys = Object.keys(userProviders);
                      this.reportProviders = [];
                      for (let k of keys) {
                          var dv = new DropdownValues();
                          dv.value = k;
                          dv.name = userProviders[k];
                          this.reportProviders.push(dv);
                      }           
                      this.reportProvider  =  this.reportProviders[0].value;
                   }
                   this.providerDisabled = true; 
                } else {
                  if (data.hasOwnProperty('providers')) {
                    let userProviders = data['providers'];
                    var keys = Object.keys(userProviders);
                    this.reportProviders = [];
                    
                    var pickup = new DropdownValues();
                    pickup.value = undefined;
                    pickup.name = "Pick an option";
                    this.reportProviders.push(pickup);                     
                    
                   /* var pickupAll = new DropdownValues();
                    pickupAll.value = "All"
                    pickupAll.name = "All";
                    this.reportProviders.push(pickupAll);*/
                    for (let k of keys) {
                        var dv = new DropdownValues();
                        dv.value = k;
                        dv.name = userProviders[k];
                        this.reportProviders.push(dv);
                    }    
                }
            }
    
          }, response => {
            console.log('Get call in error', response);
          }, () => {
    
          });
    }

    getReportMonths() {
        this.reportMonths = this.refTableService.getValueFromSharedDataMap("MONTHS");
    }

    getReportAreas() {
        this.reportAreas = this.refTableService.getValueFromSharedDataMap("AREAS");
    }

    getReportCounties() {
        this.reportCounties = this.refTableService.getValueFromSharedDataMap("COUNTIES");
    }

    getUserActionNotifications(){
        this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    }

    onChange(value) {
        if (value == '1: CC') {
            this.router.navigate(["/reports/federalReports/CC"]);
        }

        if (value == '2: CR') {
            this.router.navigate(["/reports/federalReports/CR"]);
        }

        if (value == '3: ER') {
            this.router.navigate(["/reports/federalReports/ER"]);
        }

        if(value == '4: ET') {
            this.router.navigate(["/reports/employment-training-retention"]);
        }

        if(value == '5: SD') {
            this.router.navigate(["reports/monthly-snapshot-details"]);
        }

        if(value == '6: SR') {
            this.router.navigate(["reports/monthly-snapshot-rollup"]);
        }

        if(value == '7: CA') {
            this.router.navigate(["reports/component-activity"]);
        }
        
        if(value == '8: PC') {
            this.router.navigate(["reports/potential-candidates"]);
        }
        if(value == '9: AR') {
            this.router.navigate(["reports/aries-task"]);
          }
    }

    searchSnapshotDetails(event) {
        this.firstTime = true;
        this.dataFound = true;
      
        if (this.checkMandatoryParameters())
        {
            this.searchSnapshotDetailsRequest = new SearchSnapshotDetailsVO();

            if(this.reportAreaCode !== undefined && this.reportAreaCode !== null) 
                this.searchSnapshotDetailsRequest.areaCode = this.reportAreaCode
            
            if(this.reportCounty !== undefined && this.reportCounty !== null) 
                this.searchSnapshotDetailsRequest.countyCode = this.reportCounty  
                
            if(this.reportProvider !== undefined && this.reportProvider !== null) 
                this.searchSnapshotDetailsRequest.providerCode = this.reportProvider  
            
            if(this.reportMonth !== undefined && this.reportMonth !== null) 
                this.searchSnapshotDetailsRequest.month = this.reportMonth    
            
            event.srcElement.blur();
            event.preventDefault(); 
            
            this.loadMonthlySnapshotDetailsData();
        }
    }
    
    loadMonthlySnapshotDetailsData() {
        this.http.post<SearchSnapshotDetailsVO>(this.ServerConstants.REPORT_SERVER_API_URL+'/reportTaskSummary/loadmonthlysnapshotdetails', this.searchSnapshotDetailsRequest).subscribe(
          (data:SearchSnapshotDetailsVO ) => {
            // convert date to the proper format for UI
            this.pdfDocument = true;
            this.excelDocument = true;
            this.getMonthlySnapshotDetailsColumnDefinitions();
            this.getMonthlySnapshotDetailsCountColumnDefinitions();

            this.monthlySnapshotDetailsCountRowData = [
                {
                    countCitizens : data.countCitizens, 
                    countApprovalParticipation : data.countApprovalParticipation,
                    countContactStatus : data.countContactStatus,
                    countActiveEmploymentPlan : data.countActiveEmploymentPlan,
                    countEducationLevel : data.countEducationLevel,
                    countNoncompliance : data.countNoncompliance,
                    countGoodCauseOrExcemption : data.countGoodCauseOrExcemption,
                    countCertifications : data.countCertifications,
                    countCaseClosure : data.countCaseClosure
                }];
            this.monthlySnapshotDetailsRowData = data.citizenDetails;
            this.renderedCountTableContent = this.monthlySnapshotDetailsCountRowData;
            this.renderedTableContent = data.citizenDetails;

          }, response => {
            //this.notificationService.error('Report Summary', this.userActionNotificationsMap.ERROR);
          }, () => {
    
    
          });

    }

    loadCountiesArea(areaName) {
      
        this.http.post<any>(this.ServerConstants.SERVER_API_URL + '/staticData/find/', {
          name: areaName,
          type: 'RT'
        }).subscribe((val) => {
            
            // Add "Pick an Option" to all reference tables
            if (val.dataValue !== undefined && val.dataValue.EN !== undefined) {
              val.dataValue.EN.forEach((value)=>{
                if(value.activeBeginDt!==null && value.activeBeginDt!==undefined){
                  value.activeBeginDt = this.dateUtil.formatDate1(value.activeBeginDt);
                }
                if(value.activeEndDt!==null && value.activeEndDt!==undefined){
                  value.activeEndDt = this.dateUtil.formatDate1(value.activeEndDt);
                }
              })
              var staticDataMap = val.dataValue.EN;
              staticDataMap.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
              });
              this.reportCounties = [];
              var pickup = new DropdownValues();
              pickup.value = undefined;
              pickup.name = "Pick an option";
              this.reportCounties.push(pickup);                
              var pickup = new DropdownValues();
              pickup.value = "All"
              pickup.name = "All";
              var m = new Date();
              var dateString = m.getUTCFullYear() + "/" +
              ("0" + (m.getUTCMonth()+1)).slice(-2) + "/" +
              ("0" + m.getUTCDate()).slice(-2);
              
              this.reportCounties.push(pickup);
              
              for (let d of staticDataMap) {
                  var dv = new DropdownValues();
                 
                  let d1 = new Date(dateString); 
                  if(d.activeSW == 'Y') {
                    let d2 = new Date(d.activeBeginDt);
                    if(d2 <= d1) {
                      dv.value = d.value;
                      dv.name = d.name;
                      this.reportCounties.push(dv);
                    }
                  }
              }           

            }
            
          },
          response => {
            //this.notificationService.error('Admin', this.userActionNotificationsMap.ERROR);
          },
          () => {
    
          });
      }

    onChangeMonth(value) {
        var res = value.substring(0, 2);
        var monthSelected = value.substring(0, 2);
        var yearSelected = value.substring(2, 6);
        this.reportSelectedMonthName = monthSelected + "/" + yearSelected;
    }

    onChangeArea(value) {
        var valueSelected = value.split(':')
        var id = valueSelected[0];
        this.reportSelectedAreaName = this.reportAreas[id].name;
        if(this.reportAreas[id].name !== 'All'){
            event.preventDefault();
            this.loadCountiesArea(this.reportSelectedAreaName);
        } else {
            event.preventDefault();
            this.loadUserInformation();
        }
    }

    onChangeCounty(value) {
        var valueSelected = value.split(':')
        var id = valueSelected[0].trim();
        if(id !== 'All' && id !== undefined && this.reportCounties[id] !== undefined) {
         this.reportSelectedCountyName = this.reportCounties[id].name;
        } else if(id == 'All' && id !== undefined) {
            this.reportSelectedCountyName ='All';
        } else {
          this.reportSelectedCountyName = undefined;
        }
        this.errorMandatoryFields = null;
    }


    onChangeProvider(value) {
        var valueSelected = value.split(':')
        var id = valueSelected[1].trim();
        for (var i = 0; i < this.reportProviders.length; i++) {
            if(id === this.reportProviders[i].value) {
                this.reportSelectedProviderName = this.reportProviders[i].name;
            }
        }

        this.errorMandatoryFields = null;
    }

    checkMandatoryParameters() {

        return this.checkMonthSelected() && this.checkCountyProvider();
    }
       
    checkMonthSelected() {
        if (this.reportMonth !== undefined
            && this.reportProvider !== null) {
                this.errorMandatoryMonthField = null;
                return true;
        }
        this.errorMandatoryMonthField = "Please select a Month.";
        return false;
    }

    checkCountyProvider() {  
        if(( this.reportProvider !== undefined
            && this.reportProvider !== null)) {

                if (this.reportCounty !== undefined
                && this.reportCounty !== null) {
                    this.errorMandatoryFields =   null;  
                    return true; 
                } else if (this.reportAreaCode !== undefined
                    && this.reportAreaCode !== null) {
                    this.errorMandatoryFields =   null;  
                    return true;  
                } 
        } 
        this.errorMandatoryFields = "Please select Provider and County (or Area).";
        return false;
    }

    downloadExcelKeydown(event) {
        if (event.keyCode === 32 || event.keyCode === 13) {
          this.downloadExcel(event);
        }
      }
    
      downloadPDFKeydown(event) {
        if (event.keyCode === 32 || event.keyCode === 13) {
          this.downloadnodePDF(event);
        }
      }
    

    downloadnodePDF(event){
        var width = 420;
        var height = 220;
        var temp = [420, 220];
        var doc = new jsPDF("p", "mm", "a1");
        var countRows = [];
        var rows = [];
        const col = this.monthlySnapshotDetailsColumnDefs.map(head => head.headerName);
        const colCounts = this.monthlySnapshotDetailsCountColumnDefs.map(head => head.headerName);
        const  countRow = this.renderedCountTableContent;
        
        countRow.forEach(element => {
            var row=[element.countCitizens, 
                     element.countApprovalParticipation,
                     element.countContactStatus,
                     element.countActiveEmploymentPlan,
                     element.countEducationLevel,
                     element.countNoncompliance,
                     element.countGoodCauseOrExcemption,
                     element.countCertifications,
                     element.countCaseClosure
                    ];
            countRows.push(row);
        });
        
        const rowCountModNew = this.renderedTableContent;
        rowCountModNew.forEach(element => {
            var row=[element.name, 
                     element.participation,
                     element.contactStatus,
                     element.activeEmploymentPlan,
                     element.educationLevel,
                     element.noncompliance,
                     element.goodCauseOrExcemption,
                     element.certifications,
                     element.caseClosure
                    ];
            rows.push(row);
        });

        if(this.reportSelectedAreaName !== undefined && this.reportSelectedAreaName !== null) {
            doc.text(15, 10, 'Report : Monthly Snapshot Details - ' + this.reportSelectedMonthName );
            doc.text(15, 20,  'Area : ' + this.reportSelectedAreaName
            + ' - Provider: ' + this.reportSelectedProviderName );
        } else if(this.reportSelectedCountyName !== undefined && this.reportSelectedCountyName !== null) {
            doc.text(15, 10, 'Report : Monthly Snapshot Details - ' + this.reportSelectedMonthName );
            doc.text(15, 20, 'County :'  + this.reportSelectedCountyName
            + ' - Provider: ' + this.reportSelectedProviderName );
        }

        
        doc.autoTable(colCounts, countRows, {margin: {top: 25}});
        doc.autoTable(col, rows, {margin: {top: 55}});
        doc.save('Monthly_Snapshot_Details.pdf');
      
    }

    downloadExcel(value) {
        let contentData = this.monthlySnapshotDetailsRowData;
        let contentColumns = this.monthlySnapshotDetailsColumnDefs;
        this.ws = utils.json_to_sheet(contentData);
        const ws_name = 'Monthly Snapshot Details';
        const wb: WorkBook = { SheetNames: [], Sheets: {} };
        wb.SheetNames.push(ws_name);
        wb.Sheets[ws_name] = this.ws;
        const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
        const buf = new ArrayBuffer(wbout.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== wbout.length; ++i) {
          view[i] = wbout.charCodeAt(i) & 0xFF;
         };
        saveAs(new Blob([buf], { type: 'application/octet-stream' }), 'Monthly Snapshot Details.xlsx');
    }

    gridClick() {
        this.firstTime = false;
    }

    gridCountClick() {
        this.firstTime = false;
    }

    setMonthlySnapShotDetailDisplayedRowAtIndex() {
        // get the first row
        const index = this.gridMonthlySnapshotDetailsApi.getFirstDisplayedRow();
        const rowNode = this.gridMonthlySnapshotDetailsApi.getDisplayedRowAtIndex(index);
        // scrolls to the first row
        // scrolls to the first column
        const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
        this.gridMonthlySnapshotDetailsApi.ensureColumnVisible(firstCol);
        // sets focus into the first grid cell
        this.gridMonthlySnapshotDetailsApi.setFocusedCell(index, firstCol);
    }

    setDisplayedRowAtIndex() {
        // get the first row
        const index = this.gridApi.getFirstDisplayedRow();
        const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
        // scrolls to the first row
        //this.gridApi.ensureIndexVisible(0, 'top');
        // scrolls to the first column
        const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
        this.gridApi.ensureColumnVisible(firstCol);
        // sets focus into the first grid cell
        this.gridApi.setFocusedCell(index, firstCol);
    }

    onPaginationChanged(event) {
        if (this.firstTime) {
          return;
        } else {
          if ( this.selectedValue === 1 || this.selectedValue === 2 ) {
            if ( this.gridApi ) {
              this.setDisplayedRowAtIndex();
            }
          } else if ( this.selectedValue === 3) {
            if( this.gridMonthlySnapshotDetailsApi ) {
              this.setMonthlySnapShotDetailDisplayedRowAtIndex();
            }
          }
        }
      }

    onMonthlySnapshotDetailsGridReady(params) {
        this.gridMonthlySnapshotDetailsApi = params.api;
        this.gridOptions.api = params.api;
        params.api.setGridAutoHeight(true);
        params.api.sizeColumnsToFit();
    }

    onMonthlySnapshotDetailsCountGridReady(params) {
        this.gridMonthlySnapshotDetailsCountApi = params.api;
        this.gridCountOptions.api = params.api;
        params.api.setGridAutoHeight(true);
        params.api.sizeColumnsToFit();
    }

    getMonthlySnapshotDetailsCountColumnDefinitions() {
        this.monthlySnapshotDetailsCountColumnDefs
        = [
            {
                headerName: 'Citizens',
                field: 'countCitizens'
            },
            {
                headerName: 'Contact Outcomes: Accepted Participation',
                field: 'countApprovalParticipation'
            },
            {
                headerName: 'Contact Outcomes: Successful Contact',
                field: 'countContactStatus'
            },
            {
                headerName: 'Active Employment Plans:',
                field: 'countActiveEmploymentPlan'
            },
            {
                headerName: 'Highest Education Level:',
                field: 'countEducationLevel'
            },
            {
                headerName: 'Non-compliances:',
                field: 'countNoncompliance'
            },    
            {
                headerName: 'Good Causes or Excemptions:',
                field: 'countGoodCauseOrExcemption'
            },  
            {
                headerName: 'Certifications Earned:',
                field: 'countCertifications'
            },                      
            {
                headerName: 'Cases Closure: Subsidized/Unsubsidized Employment',
                field: 'countCaseClosure'
            }
        ];       

        this.contextCount = {
          component: this
        }
      }


    getMonthlySnapshotDetailsColumnDefinitions() {
        this.monthlySnapshotDetailsColumnDefs = [
            {
                headerName: 'Citizen',
                field: 'name'
            },
            {
                headerName: 'Contact Outcome: Accepted Participation',
                field: 'participation'
            },
            {
                headerName: 'Contact Outcome: Successful Contact',
                field: 'contactStatus'
            },
            {
                headerName: 'Active Employment Plan:',
                field: 'activeEmploymentPlan'
            },
            {
                headerName: 'Highest Education Level:',
                field: 'educationLevel'
            },
            {
                headerName: 'Non-compliance:',
                field: 'noncompliance'
            },    
            {
                headerName: 'Good Cause or Excemption:',
                field: 'goodCauseOrExcemption'
            },  
            {
                headerName: 'Certifications Earned:',
                field: 'certifications'
            },                      
            {
                headerName: 'Case Closure: Subsidized/Unsubsidized Employment',
                field: 'caseClosure'
            }
        ];
        this.context = {
          component: this
        }
      }
  
      //end class
    }

export class DropdownValues {
    constructor(  
        public name?:string,
        public value?:string,
    ) {}
}

export class SearchSnapshotDetailsVO {
    constructor(
        public month?:string,
        public countyCode?:string,
        public providerCode?:string,
        public areaCode?:string,
        public countCitizens?:number,
        public countApprovalParticipation?:number,
        public countContactStatus?:number,
        public countActiveEmploymentPlan?:number,
        public countEducationLevel?:number,
        public countNoncompliance?:number,
        public countGoodCauseOrExcemption?:number,
        public countCertifications?:number,
        public countCaseClosure?:number,
        public citizenDetails?: CitizenMonthlySnapshotDetailsVO[],
    ){}
} 

export class CitizenMonthlySnapshotDetailsVO {
    constructor(
        public name?:string,
        public participation?:string,
        public contactStatus?:string,
        public activeEmploymentPlan?:string,
        public educationLevel?:string,
        public noncompliance?:string,
        public goodCauseOrExcemption?:string,
        public certifications?:string,
        public caseClosure?:string,
    ) {}
}


// WEBPACK FOOTER //
// ./src/app/monthly-snapshot-details/monthly-snapshot-details.component.ts